import { render, staticRenderFns } from "./AnalyticsPanel.vue?vue&type=template&id=0fa38ec4&scoped=true"
import script from "./AnalyticsPanel.vue?vue&type=script&lang=js"
export * from "./AnalyticsPanel.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsPanel.vue?vue&type=style&index=0&id=0fa38ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa38ec4",
  null
  
)

export default component.exports